import { motion } from 'framer-motion';
import { staggerChildren } from '../../utils/animations';

/**
 * Bento Grid Layout Component
 * Responsive grid with varying cell sizes for modern dashboard layouts
 */
export default function BentoGrid({ children, className = '' }) {
  return (
    <motion.div
      variants={staggerChildren}
      initial="initial"
      animate="animate"
      className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 ${className}`}
    >
      {children}
    </motion.div>
  );
}

export function BentoItem({ 
  children, 
  size = 'default',
  className = '' 
}) {
  const sizeClasses = {
    small: 'md:col-span-1',
    default: 'md:col-span-1',
    large: 'md:col-span-2',
    full: 'md:col-span-2 lg:col-span-3',
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ type: 'spring', stiffness: 300, damping: 30 }}
      className={`${sizeClasses[size]} ${className}`}
    >
      {children}
    </motion.div>
  );
}
